import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Layout from "../components/feature/Layout";
import NewsCategoryPage from "../pages/category/news/page";
import PlotCategoryPage from "../pages/category/plot/page";
import WorksCategoryPage from "../pages/category/works/page";
import DetailPage from "../pages/detail/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/news", element: <NewsCategoryPage /> },
      { path: "category/plot", element: <PlotCategoryPage /> },
      { path: "category/works", element: <WorksCategoryPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;